import { IconoirMenu } from '@ey-xd/motif-icon';
import {
  MotifAvatar,
  MotifButton,
  MotifChip,
  MotifDropdown,
  MotifDropdownItem,
  MotifDropdownPortal,
  MotifHeader,
  MotifHeaderLogo,
  MotifIcon,
  MotifTheme,
  MotifToggleSwitch
} from '@ey-xd/motif-react';
import { MotifIconButton } from '@ey-xd/motif-react/components/button';
import React from 'react';
import iconSvg from '../../assets/icons/icon.svg.json';
import { useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';

const ProfileMenu = () => {
  const { userDetails } = useSelector((state: any) => state.user);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [enableDark, setEnableDark] = React.useState(true);

  const toggleMenuOpen = () => {
    setMenuOpen(!menuOpen);
  };

  const { instance } = useMsal(); // Get the MSAL instance

  const handleLogout = () => {
    instance
      .logout()
      .then(() => {
        // Handle post-logout actions here, if necessary
      })
      .catch((e) => {
        console.error(e);
      });
  };

  if (!userDetails) return <></>;
  return (
    <div className="!h-full mr-5">
      <div className="!h-full !flex !items-center">
        <MotifDropdownPortal
          className="flex items-center"
          open={menuOpen}
          placement="bottom-right"
          handleClickOutside={() => setMenuOpen(false)}
          trigger={
            <div onClick={toggleMenuOpen} className="flex gap-3 items-center">
              <MotifAvatar
                className="cursor-pointer"
                displayName={userDetails?.displayName}
                email={userDetails?.mail}
                size="large"
                status="online"
                userName={userDetails?.displayName}
              />
              {/* <span className="text-xl font-medium">{userDetails?.displayName}</span> */}
              {menuOpen ? (
                <MotifIcon src={iconSvg['arrow-up']} className="w-5" title={'Arrow Up'} />
              ) : (
                <MotifIcon src={iconSvg['arrow-down']} className="w-5" title={'Arrow Down'} />
              )}
            </div>
          }
        >
          <MotifTheme variant={enableDark ? 'dark' : 'light'} />
          <MotifDropdownItem
            onClick={() => {
              setEnableDark(!enableDark);
              toggleMenuOpen();
            }}
          >
            Enable {!enableDark ? 'Dark' : 'Light'} Mode
          </MotifDropdownItem>
          <MotifDropdownItem
            onClick={() => {
              handleLogout();
              toggleMenuOpen();
            }}
          >
            Logout
          </MotifDropdownItem>
        </MotifDropdownPortal>
      </div>
    </div>
  );
};

const AppHeader = (props: any) => {
  const {setDrawerOpen, drawerOpen} = props;
  const { userDetails } = useSelector((state: any) => state.user);
  
  return (
    <MotifHeader
      style={{ zIndex: 1000000 }}
      leftComponents={<MotifIcon onClick={() => setDrawerOpen(!drawerOpen)} src={iconSvg["menu-icon"]} className="w-5 ml-5 cursor-pointer" title='Menu' />}
      logo={
        <a aria-label="EY Logo - Home" href="/">
          <MotifIcon
            aria-hidden="true"
            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTYxcHgiIGhlaWdodD0iNTc0cHgiIHZpZXdCb3g9IjAgMCA1NjEgNTc0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA2My4xICg5MjQ1MikgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+RVlfTG9nb19CZWFtX1doaXRlX1llbGxvd19DX0NNWUs8L3RpdGxlPgogICAgPGRlZnM+CiAgICAgICAgPHBvbHlnb24gaWQ9InBhdGgtMSIgcG9pbnRzPSIwLjA2IDAuOTc0IDU2MC4zOTQgMC45NzQgNTYwLjM5NCA1NzQgMC4wNiA1NzQiPjwvcG9seWdvbj4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJFWV9Mb2dvX0JlYW1fZGVmYXVsdExvZ29XaGl0ZV9ZZWxsb3dfQ19DTVlLIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cG9seWxpbmUgaWQ9IkZpbGwtMSIgZmlsbD0iI0ZGRkZGRSIgcG9pbnRzPSI4OS45MTYgNDYyLjAzMSAxOTIuNDE3IDQ2Mi4wMzEgMTkyLjQxNyA0MDIuNTExIDg5LjkxNiA0MDIuNTExIDg5LjkxNiAzNTUuNzM0IDIwMy4zMDQgMzU1LjczNCAxNjUuNjg1IDI5MC41MzcgNC45MDMgMjkwLjUzNyA0LjkwMyA1NzQgMjMxLjY2NyA1NzQgMjMxLjY2NyA1MDguODAzIDg5LjkxNiA1MDguODAzIDg5LjkxNiA0NjIuMDMxIj48L3BvbHlsaW5lPgogICAgICAgIDxnIGlkPSJHcm91cC01Ij4KICAgICAgICAgICAgPG1hc2sgaWQ9Im1hc2stMiIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8ZyBpZD0iQ2xpcC0zIj48L2c+CiAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iRmlsbC0yIiBmaWxsPSIjRkZGRkZFIiBtYXNrPSJ1cmwoI21hc2stMikiIHBvaW50cz0iMzgyLjU4OSAyOTAuNTM3IDMzNC40MzkgMzgzLjA0MiAyODYuNDA1IDI5MC41MzcgMTkyLjQxMSAyOTAuNTM3IDI5MS40NTIgNDYyLjAzMSAyOTEuNDUyIDU3NCAzNzYuMjA2IDU3NCAzNzYuMjA2IDQ2Mi4wMzEgNDc1LjM3OCAyOTAuNTM3IDM4Mi41ODkgMjkwLjUzNyI+PC9wb2x5bGluZT4KICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJGaWxsLTQiIGZpbGw9IiNGQkQwMjAiIG1hc2s9InVybCgjbWFzay0yKSIgcG9pbnRzPSI1NjAuMzk0IDAuOTc0IDAgMjA1LjUwNSA1NjAuMzk0IDEwNi41MTEgNTYwLjM5NCAwLjk3NCI+PC9wb2x5bGluZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="
          />
        </a>
      }
      fixed
      appHeaderName={<p className="flex gap-4 items-center"><span>MS AI Core</span> {userDetails?.RoleName && (<MotifChip
        title={userDetails?.RoleName}
      >
        {userDetails?.RoleName}
      </MotifChip>)}</p> as any}
      menu={<ProfileMenu />}
    />
  );
};

export default AppHeader;
